export default [
  { product: 'Baking Soda', category: 'Non-Perishables', units: 'Low' },
  { product: 'Beans', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Bottled Water', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Canned Fruit', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Canned Juice', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Canned Soup', category: 'Non-Perishables', units: 'High' },
  { product: 'Canned Tuna', category: 'Non-Perishables', units: 'Low' },
  { product: 'Canned Vegetables', category: 'Non-Perishables', units: 'High' },
  { product: 'Crackers', category: 'Non-Perishables', units: 'Low' },
  { product: 'Flour', category: 'Non-Perishables', units: 'Low' },
  { product: 'Granola', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Granola Bars', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Honey', category: 'Non-Perishables', units: 'Low' },
  { product: 'Meat Jerky', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Mixed Nuts', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Peanut Butter', category: 'Non-Perishables', units: 'High' },
  { product: 'Pepper', category: 'Non-Perishables', units: 'High' },
  { product: 'Potato Chips', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Rice', category: 'Non-Perishables', units: 'Mid' },
  { product: 'Salt', category: 'Non-Perishables', units: 'High' },
  { product: 'Vinegar', category: 'Non-Perishables', units: 'Low' },
  { product: 'Beets', category: 'Harvested', units: 'Mid' },
  { product: 'Broccoli', category: 'Harvested', units: 'Low' },
  { product: 'Crickets', category: 'Harvested', units: 'High' },
  { product: 'Cucumbers', category: 'Harvested', units: 'Low' },
  { product: 'Deer', category: 'Harvested', units: 'Out' },
  { product: 'Dog', category: 'Harvested', units: 'Low' },
  { product: 'Lentils', category: 'Harvested', units: 'High' },
  { product: 'Mushrooms', category: 'Harvested', units: 'High' },
  { product: 'Onions', category: 'Harvested', units: 'Low' },
  { product: 'Pheasant', category: 'Harvested', units: 'Mid' },
  { product: 'Pig', category: 'Harvested', units: 'Low' },
  { product: 'Potatoes', category: 'Harvested', units: 'High' },
  { product: 'Rabbit', category: 'Harvested', units: 'Mid' },
  { product: 'Radish', category: 'Harvested', units: 'Mid' },
  { product: 'Rat', category: 'Harvested', units: 'Low' },
  { product: 'Soy Beans', category: 'Harvested', units: 'Mid' },
  { product: 'Spinach', category: 'Harvested', units: 'Mid' },
  { product: 'Squirrel', category: 'Harvested', units: 'Mid' },
  { product: 'Tomatoes', category: 'Harvested', units: 'Mid' },
  { product: 'Turnips', category: 'Harvested', units: 'Mid' },
  { product: 'Acetaminophen', category: 'First Aid', units: 'Mid' },
  { product: 'Activated Charcoal', category: 'First Aid', units: 'Mid' },
  { product: 'Amlodipine', category: 'First Aid', units: 'High' },
  { product: 'Amoxicillin', category: 'First Aid', units: 'Mid' },
  { product: 'Antacid', category: 'First Aid', units: 'Low' },
  { product: 'Anti-Diarrheal', category: 'First Aid', units: 'Mid' },
  { product: 'Bandages', category: 'First Aid', units: 'High' },
  { product: 'Benzodiazepine', category: 'First Aid', units: 'Low' },
  { product: 'Birth Control', category: 'First Aid', units: 'Mid' },
  { product: 'Blood Pressure Cuff', category: 'First Aid', units: 'Low' },
  { product: 'Central Line Kit', category: 'First Aid', units: 'Low' },
  { product: 'Codeine', category: 'First Aid', units: 'Low' },
  { product: 'Cold Medicine', category: 'First Aid', units: 'Mid' },
  { product: 'Crutches', category: 'First Aid', units: 'Mid' },
  { product: 'Defibrillator', category: 'First Aid', units: 'Low' },
  { product: 'Emergency Blanket', category: 'First Aid', units: 'Low' },
  { product: 'Epinephrine', category: 'First Aid', units: 'Mid' },
  { product: 'Gauze', category: 'First Aid', units: 'Low' },
  { product: 'Glucose meter', category: 'First Aid', units: 'Mid' },
  { product: 'Goggles', category: 'First Aid', units: 'Mid' },
  { product: 'Heating Pad', category: 'First Aid', units: 'Low' },
  { product: 'Hydrogen Peroxide', category: 'First Aid', units: 'Low' },
  { product: 'Ibuprofen', category: 'First Aid', units: 'Mid' },
  { product: 'Ice Packs', category: 'First Aid', units: 'Mid' },
  { product: 'Insulin', category: 'First Aid', units: 'Mid' },
  { product: 'IV sets', category: 'First Aid', units: 'Mid' },
  { product: 'Knee Brace', category: 'First Aid', units: 'Low' },
  { product: 'Laxative', category: 'First Aid', units: 'Mid' },
  { product: 'Lisinopril', category: 'First Aid', units: 'High' },
  { product: 'Morphine', category: 'First Aid', units: 'Mid' },
  { product: 'Multivitamins', category: 'First Aid', units: 'High' },
  { product: 'Naproxen', category: 'First Aid', units: 'High' },
  { product: 'Penicillin', category: 'First Aid', units: 'High' },
  { product: 'Rubbing Alcohol', category: 'First Aid', units: 'Mid' },
  { product: 'Scalpel', category: 'First Aid', units: 'Mid' },
  { product: 'Splint', category: 'First Aid', units: 'Mid' },
  { product: 'Stethoscope', category: 'First Aid', units: 'Mid' },
  { product: 'Surgical Tool Set', category: 'First Aid', units: 'Mid' },
  { product: 'Syringe', category: 'First Aid', units: 'Mid' },
  { product: 'Thermometer', category: 'First Aid', units: 'Low' },
  { product: 'Tongue Depressor', category: 'First Aid', units: 'High' },
  { product: 'Tourniquet', category: 'First Aid', units: 'Low' },
  { product: 'Vaseline', category: 'First Aid', units: 'Mid' },
  { product: 'Wheelchair', category: 'First Aid', units: 'Low' },
  { product: 'Zolpidem', category: 'First Aid', units: 'Low' },
  { product: 'Air Fresheners', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Ammonia', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Bar Soap', category: 'Cleaning Supplies', units: 'High' },
  { product: 'Bleach', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Broom', category: 'Cleaning Supplies', units: 'Low' },
  { product: 'Bucket', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Glass Cleaner', category: 'Cleaning Supplies', units: 'Low' },
  { product: 'Gloves', category: 'Cleaning Supplies', units: 'High' },
  { product: 'Liquid Soap', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Mop', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Multi Surface Cleaner', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Paper Towels', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Plungers', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Sponges', category: 'Cleaning Supplies', units: 'Mid' },
  { product: 'Steel Wool', category: 'Cleaning Supplies', units: 'Low' },
  { product: 'Towel', category: 'Cleaning Supplies', units: 'Low' },
  { product: 'Trash Bags', category: 'Cleaning Supplies', units: 'High' },
  { product: 'Boots', category: 'Clothing', units: 'Low' },
  { product: 'Bras', category: 'Clothing', units: 'Mid' },
  { product: 'Gloves', category: 'Clothing', units: 'High' },
  { product: 'Hats', category: 'Clothing', units: 'Low' },
  { product: 'Jackets', category: 'Clothing', units: 'Mid' },
  { product: 'Pants', category: 'Clothing', units: 'Mid' },
  { product: 'Ponchos', category: 'Clothing', units: 'Low' },
  { product: 'Sandals', category: 'Clothing', units: 'Out' },
  { product: 'Scarves', category: 'Clothing', units: 'Mid' },
  { product: 'Shirts', category: 'Clothing', units: 'Mid' },
  { product: 'Shoelaces', category: 'Clothing', units: 'Mid' },
  { product: 'Shoes', category: 'Clothing', units: 'Low' },
  { product: 'Socks', category: 'Clothing', units: 'High' },
  { product: 'Underwear', category: 'Clothing', units: 'Low' },
  { product: 'Winter Coats', category: 'Clothing', units: 'Mid' },
  { product: 'AA Batteries', category: 'Misc', units: 'Mid' },
  { product: 'AAA Batteries', category: 'Misc', units: 'Mid' },
  { product: 'Backpacks', category: 'Misc', units: 'Low' },
  { product: 'Blankets', category: 'Misc', units: 'Out' },
  { product: 'C Batteries', category: 'Misc', units: 'Out' },
  { product: 'Candles', category: 'Misc', units: 'High' },
  { product: 'Capacitors', category: 'Misc', units: 'Low' },
  { product: 'Chalk', category: 'Misc', units: 'Mid' },
  { product: 'Circuit Boards', category: 'Misc', units: 'Low' },
  { product: 'Clear Tape', category: 'Misc', units: 'Low' },
  { product: 'Cups', category: 'Misc', units: 'Mid' },
  { product: 'D Batteries', category: 'Misc', units: 'Low' },
  { product: 'Deodorant', category: 'Misc', units: 'Mid' },
  { product: 'Duct Tape', category: 'Misc', units: 'Mid' },
  { product: 'Duffle Bags', category: 'Misc', units: 'Low' },
  { product: 'Feminine Pads', category: 'Misc', units: 'High' },
  { product: 'Flashlights', category: 'Misc', units: 'Mid' },
  { product: 'Floss', category: 'Misc', units: 'High' },
  { product: 'Folding Chairs', category: 'Misc', units: 'Mid' },
  { product: 'Forks', category: 'Misc', units: 'High' },
  { product: 'Glow Sticks', category: 'Misc', units: 'High' },
  { product: 'Hair Clippers', category: 'Misc', units: 'Low' },
  { product: 'Highlighters', category: 'Misc', units: 'Mid' },
  { product: 'Knives', category: 'Misc', units: 'Low' },
  { product: 'Light Bulbs', category: 'Misc', units: 'High' },
  { product: 'Lighters', category: 'Misc', units: 'Mid' },
  { product: 'Masking Tape', category: 'Misc', units: 'Low' },
  { product: 'Matches', category: 'Misc', units: 'High' },
  { product: 'Mouthwash', category: 'Misc', units: 'Low' },
  { product: 'Paper', category: 'Misc', units: 'Mid' },
  { product: 'Pencil Sharpeners', category: 'Misc', units: 'Mid' },
  { product: 'Pencils', category: 'Misc', units: 'High' },
  { product: 'Pens', category: 'Misc', units: 'High' },
  { product: 'Plates', category: 'Misc', units: 'Mid' },
  { product: 'Resistors', category: 'Misc', units: 'Low' },
  { product: 'Safety Pins', category: 'Misc', units: 'High' },
  { product: 'Scissors', category: 'Misc', units: 'Mid' },
  { product: 'Spoons', category: 'Misc', units: 'High' },
  { product: 'Staplers', category: 'Misc', units: 'High' },
  { product: 'Staples', category: 'Misc', units: 'High' },
  { product: 'Switches', category: 'Misc', units: 'Low' },
  { product: 'Tampons', category: 'Misc', units: 'High' },
  { product: 'Toothbrushes', category: 'Misc', units: 'Mid' },
  { product: 'Toothpaste', category: 'Misc', units: 'High' },
  { product: 'Walkie Talkie', category: 'Misc', units: 'Low' },
  { product: 'Allen Wrenches', category: 'Tools', units: 'Low' },
  { product: 'Axes', category: 'Tools', units: 'Mid' },
  { product: 'Bolt Cutters', category: 'Tools', units: 'Low' },
  { product: 'Crowbars', category: 'Tools', units: 'Mid' },
  { product: 'Drill Bit Sets', category: 'Tools', units: 'Mid' },
  { product: 'Drills', category: 'Tools', units: 'Low' },
  { product: 'Gas Masks', category: 'Tools', units: 'Mid' },
  { product: 'Hammers', category: 'Tools', units: 'Mid' },
  { product: 'Hand Saws', category: 'Tools', units: 'High' },
  { product: 'Knives', category: 'Tools', units: 'High' },
  { product: 'Levels', category: 'Tools', units: 'Low' },
  { product: 'Paint', category: 'Tools', units: 'Mid' },
  { product: 'Paint Brushes', category: 'Tools', units: 'Mid' },
  { product: 'Paint Rollers', category: 'Tools', units: 'Low' },
  { product: 'Power Saws', category: 'Tools', units: 'Low' },
  { product: 'Saw Horses', category: 'Tools', units: 'Low' },
  { product: 'Screwdrivers', category: 'Tools', units: 'Mid' },
  { product: 'Soldering Irons', category: 'Tools', units: 'Low' },
  { product: 'Welding Kits', category: 'Tools', units: 'Low' },
  { product: 'Wire', category: 'Tools', units: 'Mid' },
  { product: 'Wrench Sets', category: 'Tools', units: 'Low' },
  { product: 'Handgun Bullets', category: 'Defense', units: 'Low' },
  { product: 'Handguns', category: 'Defense', units: 'Mid' },
  { product: 'Hunting Arrows', category: 'Defense', units: 'Mid' },
  { product: 'Hunting Bows', category: 'Defense', units: 'Low' },
  { product: 'Rifle Bullets', category: 'Defense', units: 'Low' },
  { product: 'Rifles', category: 'Defense', units: 'Mid' },
  { product: 'Shotgun Shells', category: 'Defense', units: 'Low' },
  { product: 'Shotguns', category: 'Defense', units: 'Low' },
  { product: 'Gloves', category: 'Lab', units: 'High' },
  { product: 'Lenses', category: 'Lab', units: 'Low' },
  { product: 'Masks', category: 'Lab', units: 'High' },
  { product: 'Petri Dishes', category: 'Lab', units: 'Low' },
  { product: 'Plastic Cups', category: 'Lab', units: 'High' },
  { product: 'Scrub Brushes', category: 'Lab', units: 'Mid' },
  { product: 'Syringes', category: 'Lab', units: 'Mid' },
  { product: 'Test Tubes', category: 'Lab', units: 'Low' },
  { product: 'Vials', category: 'Lab', units: 'Mid' },
  { product: 'Wipes', category: 'Lab', units: 'High' },
]
